/**
 * UI registry: action.type → pending card.
 * Add an entry when a new ENABLED_ACTIONS capability ships.
 */

import React from 'react';
import {
  ACTION_SALE_CREATE,
  AgentAction,
  isSaleCreateAction,
} from '../../api/aiAgent';
import SaleDraftCard from './SaleDraftCard';

export interface ActionCardRenderOpts {
  disabled: boolean;
  onConfirm: (action: AgentAction, index: number) => void;
  onDismiss: (index: number) => void;
}

export function isRenderablePendingAction(action: AgentAction): boolean {
  if (action.type === ACTION_SALE_CREATE) {
    return isSaleCreateAction(action);
  }
  return false;
}

export function renderActionCard(
  action: AgentAction,
  index: number,
  opts: ActionCardRenderOpts
): React.ReactNode {
  if (action.type === ACTION_SALE_CREATE && isSaleCreateAction(action)) {
    return (
      <SaleDraftCard
        key={`action-${index}`}
        payload={action.payload}
        disabled={opts.disabled}
        onConfirm={() => opts.onConfirm(action, index)}
        onDismiss={() => opts.onDismiss(index)}
      />
    );
  }
  return null;
}
